<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <confirmProcurementPosition></confirmProcurementPosition>
    </v-dialog>
</template>

<script>
    import confirmProcurementPosition from './ConfirmProcurementPosition.vue'
    
    import {
        ProcurementPosition
    } from '../../../store/namespace-helper'

    export default {
      name: 'ConfirmProcurementPositionDialog',
      components: {
        confirmProcurementPosition
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[ProcurementPosition.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Procurements/ProcurementPositions/ConfirmProcurementPositionDialog.vue